import styles from './EgoLogo.module.css';

const EgoLogo = ({ className }) => (
  <svg
    viewBox="0 0 100 115.47"
    className={`${styles.logoSvg} ${className || ''}`}
    aria-hidden="true" // Hide from screen readers as it's decorative
  >
    <defs>
      <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#FFD700', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#FFA500', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <path
      fill="url(#goldGradient)"
      d="M50,0L93.3,25v50L50,100L6.7,75v-50L50,0z M50,10l-34.6,20v40L50,90l34.6-20v-40L50,10z"
    />
    <circle cx="50" cy="45" r="15" fill="url(#goldGradient)" />
    <path
      fill="url(#goldGradient)"
      d="M50,65 C40,65 35,55 35,55 C35,55 40,75 50,75 C60,75 65,55 65,55 C65,55 60,65 50,65z"
    />
  </svg>
);

export default EgoLogo;
